import React, { useEffect, useState } from "react";
import { saasApi } from "../../api/saasApi";
import { formatInrFromPaise } from "../../utils/validation";

export default function PaymentDashboard() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    saasApi.adminPayments("?limit=50").then((res) => setItems(res.data?.items || []));
  }, []);

  return (
    <div>
      <h1>Payment dashboard</h1>
      <table className="saas-compare-table">
        <thead>
          <tr><th>Invoice</th><th>Company</th><th>Plan</th><th>Amount</th><th>Status</th><th>Date</th></tr>
        </thead>
        <tbody>
          {items.map((p) => (
            <tr key={p.id}>
              <td>{p.invoice_number || p.id}</td>
              <td>{p.company?.company_name || p.company_id}</td>
              <td>{p.plan?.name}</td>
              <td>{formatInrFromPaise(p.amount_paise)}</td>
              <td>{p.status}</td>
              <td>{p.paid_at ? new Date(p.paid_at).toLocaleDateString("en-IN") : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
